/*
 * MultiValue Filter
 * This mixin gives a multipleValue prop for filter components that needs to work with array as v-model.
 * I.E. checkboxes o section selectors,
 */

import { toArray } from '@/utils';

export default {
  data() {
    return {
      multipleValue: [],
    };
  },
  watch: {
    value: {
      handler(value) {
        this.multipleValue = toArray(value);
      },
      immediate: true,
    },
  },
};
